import {
  ArrayInput,
  AutocompleteInput,
  BooleanField,
  Button, //
  Create,
  Datagrid,
  downloadCSV,
  ExportButton,
  FormDataConsumer,
  List,
  ListContextProvider,
  Pagination,
  ReferenceInput,
  SaveButton,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextField,
  Toolbar,
  useListContext,
  useNotify,
  useRedirect,
  useUnselectAll,
  useUpdate,
} from "react-admin";

import { Grid, Typography } from "@material-ui/core";
import jsonExport from "jsonexport/dist";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useDataProvider } from "react-admin";

const CustomPagination = (props) => {
  return <Pagination rowsPerPageOptions={[50, 100, 200]} {...props} />;
};

const AutoCompleteProgramme = () => {
  //   const form = useForm();
  return (
    <ReferenceInput
      label="Search Programme Name or ID"
      source="programme_id"
      reference="programmes-autocomplete"
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="id" fullWidth />
    </ReferenceInput>
  );
};
export const CanvasAdList = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  const [newProgrammes, setNewProgrammes] = useState([]);
  const [removedProgrammes, setRemovedProgrammes] = useState([]);

  const CustomToolbar = (props) => {
    const redirectTo = useRedirect();
    const notify = useNotify();

    const [update] = useUpdate("canvas-ad-programs");

    const handleSave = useCallback(
      async (_values, _redirect) => {
        const programmesToSend = [
          ...newProgrammes.map((p) => ({
            call_canvas_ad: false,
            programme_id: p.programme_id,
          })),
          ...removedProgrammes.map((p) => ({
            call_canvas_ad: true,
            programme_id: p.programme_id,
          })),
        ];

        if (programmesToSend.length === 0) {
          notify("No changes to save", "info");
          return;
        }

        update(
          {
            payload: {
              data: {
                programmes: programmesToSend,
              },
            },
          },
          {
            onSuccess: () => {
              notify("Success", "success");
              window.location.reload(true);
              // redirectTo("/special-program");
            },
            onFailure: (error) => {
              notify(error.message.toString(), "warning");
            },
          },
        );
      },
      [update, notify, redirectTo, newProgrammes, removedProgrammes],
    );

    return (
      <Toolbar {...props}>
        <SaveButton onSave={handleSave} />
      </Toolbar>
    );
  };

  return (
    <Create {...props} title="Remove Canvas AD Program" onFailure={onFailure}>
      <SimpleForm toolbar={<CustomToolbar />}>
        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={12}>
            <AutoCompleteProgramme />
          </Grid>
          <Grid item sm={12} md={12}>
            <TagInputs />
          </Grid>
          <Grid item sm={12} md={12}>
            <ProgrammeTable
              newProgrammes={newProgrammes}
              setNewProgrammes={setNewProgrammes}
              removedProgrammes={removedProgrammes}
              setRemovedProgrammes={setRemovedProgrammes}
              {...props}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

const ChangedProgrammeTable = ({
  newProgrammes,
  setNewProgrammes,
  removedProgrammes,
  setRemovedProgrammes,
}) => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);

  newProgrammes = newProgrammes ?? [];
  removedProgrammes = removedProgrammes ?? [];

  const ids = [...newProgrammes, ...removedProgrammes].map((p) => p.id);

  var data = [];
  for (const programme of newProgrammes) {
    data[programme.id] = { action: "add", programme: programme };
  }
  for (const programme of removedProgrammes) {
    data[programme.id] = { action: "remove", programme: programme };
  }

  var total = newProgrammes.length + removedProgrammes.length;

  const UndoButton = (props) => {
    return (
      <Button
        label="UNDO"
        onClick={() => {
          var action = props.record.action;
          var programmeId = props.record.programme.programme_id;

          if (action == "add") {
            setNewProgrammes((programmes) =>
              programmes.filter((p) => p.programme_id != programmeId),
            );
          } else if (action == "remove") {
            setRemovedProgrammes((programmes) =>
              programmes.filter((p) => p.programme_id != programmeId),
            );
          }
        }}
      />
    );
  };

  return (
    <>
      <hr />
      <Typography variant="h6">Changed List</Typography>

      <ListContextProvider
        value={{
          data: data,
          ids: ids,
          total,
          page,
          perPage,
          setPage,
          setPerPage,
          currentSort: { field: "id", order: "ASC" },
          basePath: "/posts",
          resource: "posts",
          selectedIds: [],
        }}
      >
        <Datagrid>
          <UndoButton />
          <TextField source="action" label="Action" />
          <TextField source="programme.name_tc" label="Programme Name" />
          <TextField source="programme.programme_id" label="Programme ID" />
          <BooleanField
            source="programme.call_canvas_ad"
            label="Canvas Prog (Y/N)"
          />
        </Datagrid>
        <Pagination />
      </ListContextProvider>
    </>
  );
};

const ExistingProgrammeTable = ({
  removedProgrammes,
  setRemovedProgrammes,
  ...props
}) => {
  const ExistingProgrammeTableBulkActionButtons = (props) => {
    const unselectAll = useUnselectAll();
    const { data } = useListContext(); //Get records in List

    return (
      <Fragment>
        <Button
          label="remove"
          onClick={() => {
            var arr = [];
            for (var id of props.selectedIds) {
              //Don't remove again if already removed
              const isRemoved = removedProgrammes.find((p) => p.id == id);
              if (!isRemoved) {
                if (id in data) {
                  arr.push(data[id]);
                }
              }
            }

            setRemovedProgrammes((programmes) => [...programmes, ...arr]);
            unselectAll(props.resource);
          }}
        />
      </Fragment>
    );
  };

  const exporter = (programmes) => {
    const BOM = "\uFEFF";

    const forExport = programmes.map((programme) => {
      var p = {};
      p.name_tc = programme.name_tc;
      p.programme_id = programme.programme_id;
      return p;
    });
    jsonExport(
      forExport,
      {
        headers: ["name_tc", "programme_id"], // order fields in the export
        rename: ["Programme Name", "Programme ID"],
      },
      (err, csv) => {
        downloadCSV(`${BOM} ${csv}`, "canvas_program_list"); // download as 'posts.csv` file
      },
    );
  };

  return (
    <>
      <hr />
      <Typography variant="h6">Remove Canvas AD Program List</Typography>
      <List
        {...props}
        title={<></>}
        resource="canvas-ad-programs"
        pagination={<CustomPagination />}
        perPage={50}
        empty={false}
        actions={<ExportButton />}
        exporter={exporter}
        bulkActionButtons={<ExistingProgrammeTableBulkActionButtons />}
      >
        <Datagrid>
          <TextField source="name_tc" label="Programme Name" />
          <TextField source="programme_id" label="Programme ID" />
        </Datagrid>
      </List>
    </>
  );
};

const ProgrammeTable = ({
  newProgrammes,
  setNewProgrammes,
  removedProgrammes,
  setRemovedProgrammes,
  ...props
}) => {
  const ProgrammeTableBulkActionButtons = (props) => {
    const unselectAll = useUnselectAll();
    const { data } = useListContext(); //Get records in List

    return (
      <Fragment>
        <Button
          label="add"
          onClick={() => {
            var arr = [];
            for (var id of props.selectedIds) {
              //Don't add again if already added
              const isAdded = newProgrammes.find((p) => p.id == id);
              if (!isAdded) {
                if (id in data) {
                  arr.push(data[id]);
                }
              }
            }

            setNewProgrammes((programmes) => [...programmes, ...arr]);
            unselectAll(props.resource);
          }}
        />
      </Fragment>
    );
  };

  const exporter = (programmes) => {
    const BOM = "\uFEFF";

    const forExport = programmes.map((programme) => {
      var p = {};
      p.name_tc = programme.name_tc;
      p.programme_id = programme.programme_id;
      return p;
    });
    jsonExport(
      forExport,
      {
        headers: ["name_tc", "programme_id"], // order fields in the export
        rename: ["Programme Name", "Programme ID"],
      },
      (err, csv) => {
        downloadCSV(`${BOM} ${csv}`, "program_list"); // download as 'posts.csv` file
      },
    );
  };

  return (
    <>
      <FormDataConsumer>
        {({ formData }) => {
          return (
            <>
              <Typography variant="h6">Program List</Typography>
              <List
                {...props}
                title={<></>}
                syncWithLocation={false}
                resource="ads-adgroups-programs-search"
                pagination={<CustomPagination />}
                perPage={50}
                filter={{
                  tags: formData.tags,
                  programme_id: formData.programme_id,
                }}
                empty={false}
                actions={<ExportButton />}
                exporter={exporter}
                bulkActionButtons={<ProgrammeTableBulkActionButtons />}
              >
                <Datagrid>
                  <TextField source="name_tc" label="Programme Name" />
                  <TextField source="programme_id" label="Programme ID" />
                  <BooleanField
                    source="call_canvas_ad"
                    label="Canvas Prog (Y/N)"
                  />
                </Datagrid>
              </List>
            </>
          );
        }}
      </FormDataConsumer>
      <ExistingProgrammeTable
        setRemovedProgrammes={setRemovedProgrammes}
        removedProgrammes={removedProgrammes}
        {...props}
      />
      <ChangedProgrammeTable
        newProgrammes={newProgrammes}
        setNewProgrammes={setNewProgrammes}
        removedProgrammes={removedProgrammes}
        setRemovedProgrammes={setRemovedProgrammes}
      />
    </>
  );
};

const TagInputs = () => {
  const dataProvider = useDataProvider();

  const [tagTypes, setTagTypes] = useState([]);

  useEffect(() => {
    dataProvider.getTagTypes().then((types) => {
      setTagTypes(types.data);
    });
  }, []);

  return (
    <ArrayInput source="tags" label="Program Search">
      {/* Add TransitionProps because of bug: https://github.com/marmelab/react-admin/issues/6900 */}
      <SimpleFormIterator
        disableReordering
        TransitionProps={{ enter: false, exit: false }}
      >
        {/* If want custom layout: https://stackoverflow.com/questions/60175609/arrayinput-with-simpleformiterator-of-react-admin-generate-wrong-output */}
        <SelectInput
          fullWidth
          source="tag_type"
          choices={tagTypes}
          label="Type"
        />
        <FormDataConsumer label="Value" fullWidth>
          {({ scopedFormData, getSource }) => {
            if (!scopedFormData) {
              return <></>;
            }

            return (
              <ReferenceInput
                fullWidth
                label="Value"
                source={getSource("tag_value")}
                reference="mpm-row-tag-autocomplete"
                filter={{ tag_type: scopedFormData.tag_type }}
                filterToQuery={(searchText) => {
                  if (searchText) {
                    return {
                      name_tc: searchText,
                    };
                  }
                  return {};
                }}
              >
                <AutocompleteInput
                  fullWidth
                  optionText={(record) => {
                    if (record == null) {
                      return null;
                    }
                    return record.name_tc + " " + record.name_en;
                  }}
                />
              </ReferenceInput>
            );
          }}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
};
